import { breakpoints, Inline, Stack, Text, textVariants, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css, cx, resetButtonStyle } from '@eti/styles';
import { CheckCircle, Info, WarningCircle, X } from '@phosphor-icons/react';
import variants from '../../utils/variants';
import { variantStyles } from './notificationStyles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  signal
} = vars.colors;
const iconStyles = css`
  flex-shrink: 0;
  height: 1.25rem;
  width: 1.25rem;
`;
const iconProps = {
  'aria-hidden': true,
  className: iconStyles,
  weight: 'bold'
};
const getIcon = variant => {
  switch (variant) {
    case variants.CONFIRMATION:
      return /*#__PURE__*/_jsx(CheckCircle, {
        color: signal.positive.light,
        ...iconProps
      });
    case variants.WARNING:
      return /*#__PURE__*/_jsx(WarningCircle, {
        color: signal.caution.light,
        ...iconProps
      });
    case variants.CRITICAL:
      return /*#__PURE__*/_jsx(WarningCircle, {
        color: signal.critical.light,
        ...iconProps
      });
    case variants.INFORMATION:
    default:
      return /*#__PURE__*/_jsx(Info, {
        color: signal.information.light,
        ...iconProps
      });
  }
};
const wrapperStyles = css`
  border-radius: ${vars.card.borderRadius};
  padding: 1rem;
  padding-inline-end: 2rem;
  position: relative;
`;
const titleStyles = css`
  line-height: 1.3;
`;
const contentStyles = css`
  font-size: 0.875rem;

  & h2 {
    font-size: 1rem;
    font-weight: 700;
  }
`;
const closeButtonStyles = css`
  height: auto;
  padding: 5px;
  position: absolute;
  right: 3px;
  top: 3px;

  [dir='rtl'] & {
    left: 3px;
    right: unset;
  }

  & svg {
    height: 20px;
    width: 20px;
  }

  & span {
    display: flex;
  }

  @media (min-width: ${breakpoints._970}) {
    height: auto;
  }
`;
const Notification = _ref => {
  let {
    children,
    className,
    closeButtonDataTestId,
    closeButtonLabel = '',
    dataTestId,
    iconComponent,
    onClose,
    title,
    variant
  } = _ref;
  const {
    t
  } = useTranslation();
  const closeButtonLabelText = closeButtonLabel || t('Close');
  const getAriaLabel = notificationStatus => {
    switch (notificationStatus) {
      case variants.CONFIRMATION:
        return t('ScreenReader.Notification.ConfirmationStatusMessage.AriaLabel.Text');
      case variants.CRITICAL:
        return t('ScreenReader.Notification.CriticalStatusMessageAriaLabel.Text');
      case variants.INFORMATION:
        return t('ScreenReader.Notification.InfoStatusMessage.AriaLabel.Text');
      case variants.WARNING:
        return t('ScreenReader.Notification.WarningStatusMessage.AriaLabel.Text');
      default:
        return t('ScreenReader.Notification.InfoStatusMessage.AriaLabel.Text');
    }
  };
  return /*#__PURE__*/_jsx("div", {
    "aria-label": getAriaLabel(variant),
    className: cx('etiNotification', variantStyles(variant), wrapperStyles, className),
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsxs(Inline, {
      noWrap: true,
      spacing: 8,
      children: [iconComponent || getIcon(variant), /*#__PURE__*/_jsxs(Stack, {
        spacing: 4,
        children: [title && /*#__PURE__*/_jsx(Text, {
          className: titleStyles,
          variant: textVariants._16_BOLD,
          children: title
        }), /*#__PURE__*/_jsx(Text, {
          className: contentStyles,
          children: children
        })]
      }), onClose && /*#__PURE__*/_jsx("button", {
        "aria-label": closeButtonLabelText,
        className: cx(resetButtonStyle, closeButtonStyles),
        "data-testid": closeButtonDataTestId,
        onClick: onClose,
        type: "button",
        children: /*#__PURE__*/_jsx(X, {
          color: vars.colors.text,
          size: 24,
          weight: "thin"
        })
      })]
    })
  });
};
export default Notification;
//# sourceMappingURL=Notification.js.map